import React from 'react';
import { useTrail, a } from 'react-spring';

const ListAnimation = ({ children, open = true, ...props }) => {
	const items = React.Children.toArray(children);
	const trail = useTrail(items.length, {
		config: { mass: 5, tension: 2000, friction: 200 },
		opacity: open ? 1 : 0,
		x: open ? 0 : 20,
		from: { opacity: 0, x: 20 },
	});

	return (
		<div {...props}>
			{trail.map(({ x, ...rest }, index) => {
				return (
					<a.div
						key={index}
						style={{
							...rest,
							transform: x.interpolate((x) => `translate3d(0,${x}px,0)`),
						}}
					>
						<a.div>{items[index]}</a.div>
					</a.div>
				);
			})}
		</div>
	);
};

export default ListAnimation;
